import { GridModel } from "common/models/utility-models/list-utility.model";
import { InternshipReportsModel } from "./internship-reports-data-model";

export class InternshipReportsGridModel extends InternshipReportsModel { }

export class InternshipReportsListingModel extends GridModel<InternshipReportsModel> {
  filterData: any;
}
